/**
 * How much of a message fits in a toast before it stops being something you can take in at a
 * glance and starts pushing the rest of the screen out of the way.
 */
const MAX_LENGTH_BEFORE_TRUNCATE = 140;
/**
 * Whether the message is long enough to be worth hiding behind an expander.
 *
 * Only errors truncate. A success or a neutral message is written by us and stays short; an error
 * carries whatever the backend returned, which can run to several paragraphs.
 */
export const isToastMessageTruncatable = (severity, message) => severity === 'error' && message.length >= MAX_LENGTH_BEFORE_TRUNCATE;
export const truncateToastMessage = (message) => `${message.substring(0, MAX_LENGTH_BEFORE_TRUNCATE)}...`;
